function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

/**
 * Adds a Shopify size attribute to a URL
 */
function getSizedImageUrl(src, size) {
  if (!src) {
    return src;
  }

  if (size == null) {
    return src;
  }

  if (size === 'master') {
    return src.replace(/http(s)?:/, '');
  }

  var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

  if (match != null) {
    var prefix = src.split(match[0]);
    var suffix = match[0];

    return (prefix[0] + '_' + size + suffix).replace(/http(s)?:/, '');
  }

  return null;
}

function defaultTo(value, defaultValue) {
  return (value == null || value !== value) ? defaultValue : value
}

function formatMoney(cents, format) {
  var moneyFormat = '${{amount}}';
  var superScript = window;
  
  if (!format) {
    format = window.shopSettings.moneyFormat;
  }

  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || moneyFormat);

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ',');
    decimal = defaultTo(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.');
    var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var centsAmount = parts[1] ? (decimal + parts[1]) : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);

      if (superScript && value && value.includes('.')) {
        value = value;
      }

      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');

      if (superScript && value && value.includes('.')) {
        value = value;
      }

      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    //this.mainModalClose = this.querySelector('mobile-facet-close');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    //this.mainModalClose.addEventListener('click', this.closeMenuDrawer.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    if(!this.mainDetailsToggle.classList.contains('mobile-facets__disclosure')) {
      this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
    }
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    // document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
if(!this.classList.contains('product-media-modal-featured')){
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
    }
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));console.log(modal);
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    if(poster.classList.contains('no_poster')) {
      this.checkIfVideoInView = this.checkIfVideoInView.bind(this);
      document.addEventListener('scroll', this.checkIfVideoInView);
    } else {
      poster.addEventListener('click', this.loadContent.bind(this));
    }
  }

  checkIfVideoInView() {
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    const posterBoundingClientRect = poster.getBoundingClientRect();
    const top = posterBoundingClientRect.top - 50;
    const bottom = posterBoundingClientRect.bottom + 50;
    const posterInView = top <= window.innerHeight && bottom >= 0;
    if (posterInView) {
      this.loadContent();
      this.removeVideoListener();
    }
  }

  removeVideoListener(el) {
    document.removeEventListener('scroll', this.checkIfVideoInView);
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();

      const ad = this.closest('.card-wrapper__ad');
      if (!ad) return;
      ad.classList.add('video-loaded');
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.sliderDots = this.querySelector('.slider-dots');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.firstSlide = this.sliderItems[0];
    this.lastSlide = this.sliderItems[0];
    this.index = 0;
    this.fixedOffset = 0;

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    const elementObserver = new MutationObserver(entries =>  {
      this.sliderItems = this.querySelectorAll('li');
      this.firstSlide = this.sliderItems[0];
      this.lastSlide = this.sliderItems[0];
    });
    elementObserver.observe(this.slider,{
      childList: true,
      subtree: true,
      attributes: false,
      characterData: false,
    });

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

    if (this.sliderDots) {
      this.sliderDot = this.sliderDots.querySelectorAll('div')
      this.sliderDots.addEventListener('click', this.onDotClick.bind(this));
    }
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;

    this.lastSlide = this.sliderItems[this.totalPages - 1];

    if(!this.slider.classList.contains('loaded') && this.enableSliderLooping) {
      const cloneFirst = this.firstSlide.cloneNode(true);
      const cloneLast = this.lastSlide.cloneNode(true);

      cloneFirst.classList.add('cloned');
      cloneLast.classList.add('cloned');

      this.slider.appendChild(cloneFirst);
      this.slider.insertBefore(cloneLast, this.firstSlide);

      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      
      this.slider.classList.add('loaded');

      this.slider.scrollTo({
        left: this.firstSlide.offsetLeft
      });
    }

    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;

    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;
    if(this.slider.classList.contains('loaded') && this.enableSliderLooping) {
      this.currentPage = Math.round((this.slider.scrollLeft - this.sliderLastItem.clientWidth)/ this.sliderLastItem.clientWidth) + 1
    }

    if(this.currentPage > this.totalPages) {
      this.currentPage = 1;
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;

    if(!this.sliderDots) return;

    var lis = this.sliderDots.querySelectorAll('div'),
        visible_slides = Array.from(this.sliderItems).filter(s =>
          window.getComputedStyle(s).getPropertyValue('display') != 'none'
        );
    [].forEach.call(lis, function (el) {
      el.classList.remove('slider-dots--show');
    });
    for (var i = 0; i < visible_slides.length; i++) {
      lis[i].classList.add('slider-dots--show');
    }
  }

  onScroll() {
    if (this.slider.scrollLeft.toFixed() === this.fixedOffset) {
      if (this.index < 0 || this.index == this.totalPages) {
        let goTo = this.sliderLastItem.clientWidth;
        let newIndex = 0;
        if (this.index < 0) {
          goTo = this.sliderLastItem.clientWidth * this.totalPages;
          newIndex = this.totalPages - 1;
        }
        this.slider.style.scrollBehavior = 'auto';
        this.index = newIndex;
        this.slider.scrollTo({
          left: goTo
        })
        this.slider.style.removeProperty('scroll-behavior');
      }
      this.slider.removeEventListener('scroll', this.onScroll);
    }

    if(!this.sliderDots) return;

    [].forEach.call(this.sliderDot, function (el) {
      el.classList.remove('current');
    });
    this.sliderDot[this.index].classList.add('current');
  }

  scrollToSlide(offset) {
    this.fixedOffset = offset.toFixed();
    this.slider.addEventListener('scroll', this.onScroll.bind(this));
    this.onScroll();
    this.slider.scrollTo({
      left: offset
    })
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.index = event.currentTarget.name === 'next' ? this.index += 1 : this.index -= 1;
    this.scrollToSlide(this.slideScrollPosition);
  }

  onDotClick(event) {
    var visible_slides = Array.from(this.sliderItems).filter(s =>
          window.getComputedStyle(s).getPropertyValue('display') != 'none'
        );
    this.index = event.target.textContent;
    this.scrollToSlide(visible_slides[event.target.textContent].clientWidth*event.target.textContent);
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = this.sliderFirstItemNode.clientWidth;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    this.slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.updateOptions();
    this.updateSoldOut();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateSoldOut();
    this.updateFieldsetText();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateFeatures();
      this.updateDimensions();
      this.updateBundleItemsFeature();
    }
  }

  updateBundleItemsFeature() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
    .then((response) => response.text())
    .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const featureDestination = document.getElementById(`items-feature-${this.dataset.section}`);
        const featureSource = html.getElementById(`items-feature-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
    
        if (featureSource && featureDestination) {
          featureDestination.innerHTML = featureSource.innerHTML;
          initItemPopup();
        }
    })
  }

  checkData() {
    this.parentProduct = this.hasAttribute('data-parent');
    this.optionBase = this.dataset.base.split(',').length;
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateFeatures() {
    if (!this.currentVariant) return;
  
    const variantFeatures = document.querySelectorAll('.product-features-specs');
    const selectedVariantFeature = document.querySelector(`[data-variantid="${this.currentVariant.id}"]`);
  
    if (!selectedVariantFeature) {
      console.warn(`No feature found for variant ID: ${this.currentVariant.id}`);
      return;
    }
  
    const availableContent = selectedVariantFeature.getAttribute('data-available-content');
  
    variantFeatures.forEach((variantFeature) => {
      variantFeature.classList.remove('active'); 
    });
  
    if (availableContent === 'true') {
      selectedVariantFeature.classList.add('active');
    } else {
      document.querySelector('.js-product-features-content')?.classList.add('active');
    }
  }

  updateDimensions() {
    const productDimension = document.querySelector('product-dimensions');
    const selectedVariantDimension = document.querySelector(`.product-dimension-cell[data-id="${this.currentVariant.id}"]`);
    const availableDimensions = productDimension?.querySelectorAll('.product-dimension-cell');
    const productId = this.getAttribute('data-product');
    const productDimensionCell = document.querySelector(`.product-dimension-cell[data-id="${productId}"]`);

    if(selectedVariantDimension){
      availableDimensions.forEach((variantDimension) => {
        variantDimension.style.display = 'none';
      });

      selectedVariantDimension.style.display = 'block';
    }else{
      if(productDimensionCell){
        availableDimensions.forEach((variantDimension) => {
          variantDimension.style.display = 'none';
        });
        productDimensionCell.style.display = 'block';
      }
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    if (!mediaGallery) return;

    const mediaViewer = mediaGallery.querySelector('[id^="GalleryViewer"]');
    const hideVariantsRaw = mediaGallery.getAttribute('data-hide-variants');
    const hideVariantsEnabled = hideVariantsRaw === 'true';

    const productId = mediaGallery.getAttribute('data-productid');
    const sectionId = mediaGallery.getAttribute('data-sectionid');

    if (hideVariantsEnabled && sectionId && productId) {
      const jsonEl = document.querySelector(`#ProductMediaJSON-${productId}`);
      let mediaJson = [];

      if (jsonEl?.textContent) {
        try {
          mediaJson = JSON.parse(jsonEl.textContent);
        } catch (_) {
          mediaJson = [];
        }
      }

      const newBundleTemplate = document.querySelector('.new-bundle-gallery-template');
      const color_option_index = mediaGallery.getAttribute('data-colo-index') || 'option1';

      let optionColorName = this.currentVariant[color_option_index];
      if (newBundleTemplate && this.currentVariant.title) {
        optionColorName = String(this.currentVariant.title).replace(/\s*\|\s*/g, ' / ');
      }

      const currentVariantTitle = String(this.currentVariant.title || '')
        .replace(/\s*\|\s*/g, ' / ')
        .trim();
      const variantOptions = (this.currentVariant.options || [])
        .map((o) => String(o || '').trim())
        .filter(Boolean);
      const variantData = this.getVariantData();
      const hasOnlyDefaultVariant = Array.isArray(variantData) && variantData.length === 1;

      const shouldShowMedia = (media) => {
        if (!media) return false;
        if (hasOnlyDefaultVariant) return true;

        const altTrim = media.alt != null ? String(media.alt).trim() : '';
        if (altTrim === 'ALL') return true;

        if (currentVariantTitle && altTrim.includes(currentVariantTitle)) return true;

        const segments = altTrim.length
          ? altTrim.split('|').map((s) => s.trim()).filter(Boolean)
          : [];

        const colorStr = optionColorName != null ? String(optionColorName).trim() : '';

        for (const seg of segments) {
          if (seg === 'ALL') return true;
          if (colorStr && seg === colorStr) return true;
          if (variantOptions.some((opt) => seg === opt)) return true;
          if (
            currentVariantTitle &&
            (seg.includes(currentVariantTitle) || currentVariantTitle.includes(seg))
          ) {
            return true;
          }
        }

        return false;
      };

      mediaJson.forEach((media) => {
        const mediaId = `${sectionId}-${media.id}`;
        const cell = mediaGallery.querySelector(`[data-media-id="${mediaId}"]`);
        if (!cell) return;

        if (shouldShowMedia(media)) {
          cell.classList.add('product__media-item--variant_current', 'is-active');
        } else {
          cell.classList.remove('product__media-item--variant_current', 'is-active');
        }
      });
    }

    if (mediaViewer && typeof mediaViewer.initPages === 'function') {
      mediaViewer.initPages();
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateSoldOut() {
    const optionElements = Array.from(this.querySelectorAll("fieldset"));
    const newBundleGallery = document.querySelector('.new-bundle-gallery-template');

    if (!optionElements) return;

    // Current selections
    this.optionValues = optionElements.map((el) => {
      return el.tagName === "SELECT"
        ? el.value
        : Array.from(el.querySelectorAll("input")).find(r => r.checked)?.value;
    });

    // Reset everything
    optionElements.forEach((fieldset) => {
      fieldset.querySelectorAll("input").forEach((input) => {
        input.classList.remove("disabled", "soldout");
      });
    });

    // Apply filtering for each fieldset
    optionElements.forEach((fieldset, fieldsetIndex) => {
      fieldset.querySelectorAll("input").forEach((input) => {
        const candidateSelection = [...this.optionValues];
        candidateSelection[fieldsetIndex] = input.value;

        const matchingVariant = this.getVariantData().find((variant) => {
          return candidateSelection.every((val, i) => {
            return !val || variant[`option${i + 1}`] === val;
          });
        });

        if (!matchingVariant) {
          console.log("Variant doesn’t exist at all");
          input.classList.add("disabled", "not-exist");
        } else if (!matchingVariant.available) {
          console.log("Variant exists but is sold out");
          input.classList.add("disabled", "soldout");
        } else {
          console.log("✅ Variant is valid and in stock");
        }

        // if (!matchingVariant || !matchingVariant.available) {
        //   input.classList.add("disabled", "soldout");
        // }
      });
    });

    if (newBundleGallery) {
      let variantFields = document.querySelectorAll('fieldset.product-form__input');
      variantFields.forEach(label => {
        let checkedInput = label.querySelector('input:checked');
        if (checkedInput && checkedInput.classList.contains('disabled')) {
          let validInput = label.querySelector('input:not(.disabled)');
          if (validInput) {
            validInput.nextElementSibling.click();
          }
        }
      });
    }
  }

  updateFieldsetText() {
    const currOptions = this.options;
    const fieldsets = this.querySelectorAll('fieldset');
    fieldsets.forEach((fieldset,index) => {
      const optionValue = fieldset.querySelector('legend span');
      optionValue.innerText = currOptions[index];
    });
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const sectionId = this.dataset.section;
    const sectionScope =
      document.getElementById(`shopify-section-${sectionId}`) ||
      document.getElementById(`MainProduct-${sectionId}`) ||
      this.closest('[id^="MainProduct-"]');

    const pickUpAvailability = sectionScope?.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      const variantId = this.currentVariant.id;
      pickUpAvailability.dataset.variantId = String(variantId);
      const runFetch = () => {
        if (typeof pickUpAvailability.fetchAvailability === 'function') {
          pickUpAvailability.fetchAvailability(variantId);
          return true;
        }
        return false;
      };
      if (!runFetch()) {
        customElements.whenDefined('pickup-availability').then(runFetch);
      }
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

renderProductInfo() {
    console.log(this.dataset.url)
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html')
            const destination = document.getElementById(`price-${this.dataset.section}`);
            const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

            if (source && destination) {
                destination.innerHTML = source.innerHTML;

                // Compare regular and sale prices
                const regularPrice = destination.querySelector('.price-item--regular')?.textContent.trim();
                const salePrice = destination.querySelector('.price-item--sale.price-item--last')?.textContent.trim();
                const salePriceContainer = destination.querySelector('.price__sale');
                const salePriceInfo = document.querySelector('.information__variant-price-promo');
                console.log(regularPrice + " = " + salePrice );
                // Hide sale price container if prices are the same
                if (regularPrice === salePrice && salePriceContainer) {
                    salePriceContainer.style.display = 'none';
                    salePriceInfo.style.display = 'none';
                } else{
                  if(salePrice == "$0" || salePrice == "$0.00" ){
                    salePriceContainer.style.display = 'none';
                  //  salePriceInfo.style.display = 'none';
                  }else{
                    salePriceContainer.style.display = 'inline-block';
                    salePriceInfo.style.display = 'block'
                  }
                }
            }

            const bundledestination = document.getElementById(`bundle-price-${this.dataset.section}`);
            const bundlesource = html.getElementById(`bundle-price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

            if (bundlesource && bundledestination) bundledestination.innerHTML = bundlesource.innerHTML;

            const price = document.getElementById(`price-${this.dataset.section}`);
            if (price) price.classList.remove('visibility-hidden');

            this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        });
}

    toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
    let soldBufferqty = false
      let variantSelectedId = document.querySelector(`.onloadcheckingsoldvarinat span[variant-id="${this.currentVariant.id}"`);
        if (variantSelectedId) {
        const variantQty = parseInt(variantSelectedId.getAttribute('variant-qty'));
        const variantMetaQty = parseInt(variantSelectedId.getAttribute('variant-metaqty'));
        if (variantQty && variantQty <= variantMetaQty) {
            const submitBtnProduct = document.querySelector('.sidebar__inner-padding .product-form__buttons');
    
            if (submitBtnProduct) {
                soldBufferqty = true
                
            }
        }
    }
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    }else if(soldBufferqty){
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }
    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  removeAllChildNodes(parent) {
    while (parent.firstChild) {
      parent.removeChild(parent.firstChild);
    }
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class TooltipOpener extends HTMLElement {
  constructor() {
    super();

    const tooltip = new bootstrap.Tooltip(this)
  }
}

customElements.define('tooltip-component', TooltipOpener);


// WICK SPECIFIC FUNCTIONALITY


function serializeJSON(form) {
  const formData = new FormData(form);
  const pairs = {}
  const consistent = {};
  for (const [name, value] of formData) {
    if(value === null || value === '' || JSON.stringify(value) === '{}') {
      continue
    } else if (name == 'form_type' || name == 'utf8') {
      consistent[name] = value;
    } else {
      pairs[name] = value;
    }
  }
  return JSON.stringify({ consistent, data: pairs }, null, 2);
}

class FormBuilder extends HTMLElement {
  constructor() {
    super();
    this.form = document.querySelector('#warranty-form');
    this.thanks = document.querySelector('#thanks');
    this.form_submit = document.getElementById('custom-form-submit');

    if(!this.form) return;

    this.form.addEventListener('submit', this.formSubmit.bind(this));
    this.querySelectorAll('.field__input-file').forEach(
      (input) => input.addEventListener('change', this.onFileInput.bind(this))
    );
  }

  onFileInput(event) {
    const input = event.target;
    const file_link = input.nextElementSibling;
    if( input.files ) {
      this.form_submit.classList.add('button--loading');
      this.form_submit.disabled = true;

      const file = input.files[0];
      const formData = new FormData();
      formData.append('file', file);
      formData.append('document', this.form_submit.dataset.source);

      var res = Array.from(formData.entries(), ([key, prop]) => (
        {[key]: {
          "ContentLength":
          typeof prop === "string"
          ? prop.length
          : prop.size
        }
        }
      ));

      if (file.size > 5000000) {
        alert('File size too large, please reduce file size and resubmit');
        input.value = '';
      } else {

        fetch('https://hook.us1.make.celonis.com/w8t8ljcq6yo7mhzstvxfn1cy1wejfe4a', {
          method: 'POST',
          body: formData
        })
        .then(response => response.text())
        .then(data => {
          file_link.value = data;
          this.form_submit.classList.remove('button--loading');
          document.getElementById('custom-form-submit').disabled = false;
        })
        .catch((error) => {
          this.form_submit.classList.remove('button--loading');
          document.getElementById('custom-form-submit').disabled = false;
        });

      }
    }
  }

  formSubmit(event) {
    event.preventDefault();
    this.form_submit.classList.add('animate');
    let redirect_url;
    if(this.hasAttribute('data-redirect')) {
      redirect_url = this.dataset.redirect;
    }
    fetch(this.dataset.send, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: serializeJSON(this.form)
    })
    .then(response => response.json())
    .then(data => {
      var form_error = document.getElementById('form_error');
      if(!form_error) {
        form_error = document.createElement('div');
        form_error.id = 'form_error';
        this.form_submit.parentNode.insertBefore(form_error, this.form_submit.nextSibling);
      }
      this.form_submit.classList.remove('animate');
      this.form_submit.classList.add('success');
      setTimeout(function(){
        this.form.classList.add('hidden');
        this.thanks.classList.remove('hidden');
        this.thanks.scrollIntoView();
        if(data.success) {
          if(redirect_url) {
            setTimeout(function(){
              window.location.href = redirect_url;
            },500);
          }
        } else {
          form_error.innerText = data.reason;
        }
      }.bind(this),500);
    })
    .catch((error) => {
      console.error('Error:', error);
      this.form_submit.classList.remove('animate');
      this.form_submit.classList.add('error');
    });
  }
}

customElements.define('form-builder', FormBuilder)

class ApplyProcode extends HTMLElement {
  constructor() {
    super();
    this.procodeForm = document.getElementById('pro-code--form');
    this.container = document.getElementById('procode');
    this.thanks = document.getElementById('pro-code--thanks');

    this.procodeForm.addEventListener('submit', this.procodeCheck.bind(this));
  }

  procodeCheck(event) {
    event.preventDefault();
    const form = event.target;
    const form_submit = form.querySelector('button');
    let redirect_url;
    if(this.hasAttribute('data-redirect')) {
      redirect_url = this.dataset.redirect;
    }
    form_submit.disabled = true;
    form_submit.classList.add('button--loading');
    fetch('https://hook.us1.make.celonis.com/kw9tflnjygyemybiuf9b3howlw8nq86b', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: serializeJSON(form)
    })
    .then(response => response.json())
    .then(data => {
      form_submit.disabled = false;
      form_submit.classList.remove('button--loading');
      var form_error = document.getElementById('form_error');
      if(!form_error) {
        form_error = document.createElement('div');
        form_error.id = 'form_error';
        form_submit.parentNode.insertBefore(form_error, form_submit.nextSibling);
      }
      if(data.success) {
        this.form.classList.add('hidden');
        this.thanks.classList.remove('hidden');
        this.thanks.scrollIntoView();
        if(redirect_url) {
          setTimeout(function(){
            window.location.href = '/pages/pro-signup-thank-you';
          },500);
        }
      } else {
        form_error.innerText = data.reason;
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}

customElements.define('apply-procode', ApplyProcode)

String.prototype.imgURL = function(size) {
  return this
    .replace(/\.jpg|\.png|\.gif|\.jpeg/g, function(match) {
      return '_'+size+match;
    })
  ;
};

/*
 * @license Basictable - Vanilla JS | MIT | Jerry Low | https://www.github.com/jerrylow/basictable
 */
"use strict";class basictable{constructor(t,e={}){this.tableSel=t,this.options={breakpoint:null,containerBreakpoint:null,contentWrap:!0,forceResponsive:!0,noResize:!1,tableWrap:!1,showEmptyCells:!1,header:!0,...e},null===this.options.breakpoint&&null===this.options.containerBreakpoint&&(this.options.breakpoint=568),this._getTables(),this._setup()}_getTables(){this.tables=document.querySelectorAll(this.tableSel)}_setup(){this.tables.forEach((t=>{t.setAttribute("data-bt-active",!0);const e=[];if(this.options.tableWrap){const e=document.createElement("div");e.classList.add("bt-wrapper"),t.parentNode.insertBefore(e,t),e.appendChild(t)}if(this.options.header){let s="";s=t.querySelectorAll("thead tr th").length?"thead th":t.querySelectorAll("tbody tr th").length?"tbody tr th":t.querySelectorAll("th").length?"tr:first th":"tr:first td",t.querySelectorAll(s).forEach((t=>{const s=parseInt(t.getAttribute("colspan"),10)||1,i=t.closest("tr"),o=[].indexOf.call(i.parentElement.children,i);e[o]||(e[o]=[]);for(let i=0;i<s;i++)e[o].push(t)})),t.querySelectorAll("tbody tr").forEach((t=>this._setupRow(t,e))),t.querySelectorAll("tfoot tr").forEach((t=>this._setupRow(t,e)))}this.options.noResize||this._check(t)})),this.options.noResize||(this._tableResizeEvent=()=>this._resize(),window.addEventListener("resize",this._tableResizeEvent))}_setupRow(t,e){t.querySelectorAll(":scope > *").forEach((t=>{if(""!==t.innerHTML.trim()&&"&nbsp;"!==t.innerHTML||!this.options.showEmptyCells){const s=[].indexOf.call(t.parentElement.children,t);let i="";for(let t=0;t<e.length;t++){0!==t&&(i+=": ");i+=e[t][s].textContent}t.setAttribute("data-th",i);const o=document.createElement("span");if(o.classList.add("bt-content"),this.options.contentWrap&&t.firstChild!==o)for(t.appendChild(o);t.firstChild!==o;)o.appendChild(t.firstChild)}else t.classList("bt-hide")}))}_check(t){if(this.options.forceResponsive)null!==this.options.breakpoint&&window.innerWidth<=this.options.breakpoint||null!==this.options.containerBreakpoint&&t.parentElement.offsetWidth<=this.options.containerBreakpoint?this._start(t):this._end(t);else{t.classList.remove("bt");t.getBoundingClientRect().left+t.offsetWidth>t.parentElement.offsetWidth?this._start(t):this._end(t)}}_start(t){t.classList.add("bt"),this.options.header||t.classList.add("bt--no-header"),this.options.tableWrap&&t.closest(".bt-wrapper").classList.add("active")}_end(t){t.classList.remove("bt","bt--no-header"),this.options.tableWrap&&t.closest(".bt-wrapper").classList.remove("active")}_resize(t){this.tables.forEach((t=>{t.getAttribute("data-bt-active")&&this._check(t)}))}start(){this.tables.forEach((t=>{this._start(t)}))}stop(){this.tables.forEach((t=>{this._end(t)}))}restart(){this.destroy(),this._getTables(),this._setup()}destroy(){this.tables.forEach((t=>{if(t.getAttribute("data-bt-active")){t.classList.remove("bt","bt--no-header"),t.removeAttribute("data-bt-active");const e=t.querySelectorAll("td");e.forEach((t=>t.removeAttribute("data-th"))),this.options.contentWrap&&e.forEach((t=>{const e=t.querySelector(".bt-content");e&&(t.innerHTML=e.innerHTML)})),this.options.tableWrap&&(t.parentNode.outerHTML=t.parentNode.innerHTML)}})),this.options.noResize||window.removeEventListener("resize",this._tableResizeEvent)}}

class SizeChart extends HTMLElement {
  constructor() {
    super();
    
    this.addEventListener('change', this.uniteChange);
  }

  uniteChange() {
    const sizeToggles = this.querySelectorAll('input');
    const sizeTables = this.querySelectorAll('.size-chart-table');
    if(sizeToggles && sizeTables){
      let selectedValue;
      for (var i = 0; i < sizeToggles.length; i++) {
        if (sizeToggles[i].type = "radio") {        
          if (sizeToggles[i].checked){
            selectedValue = sizeToggles[i].value;

            sizeTables.forEach((sizeTable) => {
              sizeTable.classList.remove('active');
              const tableType = sizeTable.getAttribute('data-type');

              if(tableType == selectedValue){
                sizeTable.classList.add('active');
              }
            })
          }
        }
      }
    }
  }
}
customElements.define('size-chart', SizeChart);

class FeaturesImages extends HTMLElement {
  constructor() {
    super();

    this.selector = document.querySelector(`variant-selects[data-product="${this.dataset.product}"]`);
    if(!this.selector) {
      this.selector = document.querySelector(`variant-radios[data-product="${this.dataset.product}"]`);
      const fieldsets = Array.from(this.selector.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    } else {
      this.options = Array.from(this.selector.querySelectorAll('select'), (select) => select.value);
    }

    this.parentProduct = this.selector.hasAttribute('data-parent');
    this.galleryEl = this.querySelector('[id^="GalleryViewer"]');
    this.slideshowEl = this.querySelector('[id^="Slider-Gallery-"]');
    this.optionBase = this.selector.dataset.base.split(',').length;

    const mediaGallery = document.getElementById(`MediaGallery-${this.selector.dataset.section}`);
    const mediaViewer = mediaGallery.querySelector('[id^="GalleryViewer"]');

    const dataConnect = this.options.slice(0,this.optionBase).join(' / ');
    const featureSpecificMedia = mediaViewer.querySelectorAll(`[data-connect="${ dataConnect }"][data-feature="true"]`);

    var mediaLoop = new Promise((resolve, reject) => {
      featureSpecificMedia.forEach((element, index, array) => {
        let clonedImage = element.querySelector('.product__media').cloneNode(true);
        let wrapper = document.createElement('li');
        wrapper.classList.add('product__modal-opener--image','slider__slide');
        wrapper.appendChild(clonedImage);
        this.slideshowEl.appendChild(wrapper);

        if (index === array.length -1) resolve();
      });
    });

    if(featureSpecificMedia.length > 0) {
      mediaLoop.then(() => {
        this.galleryEl.initPages();
      });
    }
  }
}
customElements.define('features-images', FeaturesImages);

class ShopTheLookForm extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select[name^="options"]'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    const featuredImage = this.currentVariant.featured_image;
    if(!featuredImage) return;
    const variantImage = this.closest('.row').querySelector('.media img');
    let featuredImageSrc = featuredImage.src;
    variantImage.removeAttribute('srcset');
    variantImage.src = featuredImageSrc.imgURL('750x');
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#ProductFormShopTheLook-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    
    const idSwitcher = this.querySelector('select[name="product-change"]');
    const productUrl = idSwitcher ? idSwitcher.options[idSwitcher.selectedIndex].dataset.url : this.dataset.url
    fetch(`${productUrl}?variant=${this.currentVariant.id}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        this.productElement = html.querySelector('section[id^="MainProduct-"]');
        this.sectionId = this.productElement.dataset.section;
        const destination = document.getElementById(`price-${this.sectionId}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`ProductFormShopTheLook-${this.dataset.productid}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`ProductFormShopTheLook-${this.dataset.productid}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.productid}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    const idSwitcher = this.querySelector('select[name="product-change"]');
    const currentProductId = idSwitcher ? idSwitcher.options[idSwitcher.selectedIndex].dataset.product : this.dataset.productid;
    const variantJSON = this.closest('.shop-the-look__popup-content').querySelector(`[type="application/json"][data-productId="${currentProductId}"]`);
    this.variantData = JSON.parse(variantJSON.textContent);
    return this.variantData;
  }
}
customElements.define('shop-form', ShopTheLookForm);


class CollectionSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.grid--collection_slider');
    this.sliderItems = this.querySelectorAll('.grid__item_collection');

    if (!this.slider || this.sliderItems.length < 2) return;

    new Glider(this.slider,{
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: {
        prev: '.glider-prev',
        next: '.glider-next'
      }
    });
  }
}

customElements.define('collection-slider', CollectionSlider);

class cardWrapper extends HTMLElement {
  constructor() {
    super();
    this.swatchItems = this.querySelectorAll('.variant_label--color__image');
    this.pricePromo = this.querySelector('[data-promo]');
    this.variantBadge = this.querySelector('[data-badge]');
    this.variants = JSON.parse(this.querySelector('[type="application/json"]').textContent);

    this.swatchItems.forEach((swatchItem) => {
      swatchItem.addEventListener("mouseover", this.informationUpdate.bind(this))
    })
  }

  informationUpdate(e){
    e = window.event || e;
    
    const item = e.target.closest('label');
    const variantBadge = item.getAttribute('data-variant-badge');
    const pricePromo = item.getAttribute('data-variant-promo');
    const variantId = item.getAttribute('data-variant-id');
    const variantImage = item.getAttribute('data-variant-image');
    const cardMedia = this.querySelector('img.card-hoverimg');
    const priceWrap = this.querySelector('.information__variant-price-wrap');

    if(variantImage != 'no-image'){
      const variantImageUrl = `${getSizedImageUrl(variantImage, '500x')}`;

      cardMedia.removeAttribute('srcset');
      cardMedia.setAttribute('src', variantImageUrl);
    }
    this.variantBadge.innerText = variantBadge;
    this.pricePromo.innerText = pricePromo;

    const selectedVariants = this.variants.variants;
    const selectedVariant = selectedVariants.find(element => element.id == variantId);
    let variantPriceContent = '';

if(selectedVariant.salePrice){
  // Convert string prices to numbers by removing currency symbols and parsing
  const comparePrice = parseFloat(selectedVariant.comparePrice.replace(/[^0-9.-]+/g, ''));
  const variantPrice = parseFloat(selectedVariant.price.replace(/[^0-9.-]+/g, ''));
  const priceDifference = comparePrice - variantPrice;
  
  variantPriceContent = `<span class="visually-hidden visually-hidden--inline">Sale price</span>
      <span data-product-price class="product__price on-sale">${selectedVariant.price}</span>
      <span class="visually-hidden" aria-hidden="false">Regular price</span>
      <span data-product-price-wrap>
        <span data-compare-price class="price-item price-item--regular">${selectedVariant.comparePrice}</span>
      </span>
      <span data-product-price-off class="price-item price-item--off tester" style="display:none;">$${priceDifference.toFixed(2)} Off</span>`;
}else{
  variantPriceContent = `<span class="visually-hidden visually-hidden--inline">Sale price</span>
      <span data-product-price class="product__price on-sale">${selectedVariant.price}</span>`;
}

    priceWrap.innerHTML = variantPriceContent;
  }
}

customElements.define('card-wrapper', cardWrapper);

class CardSwitcher extends HTMLAnchorElement {
  constructor() {
    super();

    this.addEventListener('click', this.colorSwitch);
  }

  colorSwitch(e) {
    e = window.event || e;
    let target = e.target;
    let mainImg = this.querySelector('.card-mainimg');
    let hoverImg = this.querySelector('.card-hoverimg');
    if(target.classList.contains('card-variant')) {
      e.preventDefault();
      let id = target.dataset.id;
      let href = this.href;
      let hrefSplit = href.split('?');
      let combinator = '';
      let elems = this.querySelectorAll('.card-information__variant-image');
      [].forEach.call(elems, function(el) {
        el.classList.remove('current');
      });
      target.closest('.card-information__variant-image').classList.add('current');
      if(hrefSplit[1] !== undefined) {
        combinator = '&' + hrefSplit[1];
      }
      let newHref = hrefSplit[0] +'?variant='+ id + combinator;
      this.setAttribute('href', newHref);
      let ogSrc = this.src;
      let targetSrc = target.dataset.featured;
      if(ogSrc != targetSrc) {
        let targetSrcset = target.dataset.featuredsrcset;
        let targetAlt = target.getAttribute('alt');
        mainImg.setAttribute('src', targetSrc);
        mainImg.setAttribute('srcset', targetSrcset);
        mainImg.setAttribute('alt', targetAlt);
        let targetHoverSrc = target.dataset.hover;
        if (targetHoverSrc !== '') {
          let targetHoverSrcset = target.dataset.hoversrcset;
          hoverImg.setAttribute('src', targetHoverSrc);
          hoverImg.setAttribute('srcset', targetHoverSrcset);
        }
      }
    }
  }
}

customElements.define('card-switcher', CardSwitcher, {extends: 'a'});

class MediaIconWrap extends HTMLElement {
  constructor() {
    super();

    const videoWrap = this.closest('.media-video');
    const refreshIcon = videoWrap.querySelector('.js-refresh-video-handle');
    const video = videoWrap.querySelector("video");
    
    this.addEventListener("click", function (e) {
      this.classList.toggle("active");
      
      const video = videoWrap.querySelector("video");
  
      if(video){
        if (video.paused) {
          video.play();
          video.muted = false;
        }else{
          video.pause();
        }
      }
    });

    if(refreshIcon){
      refreshIcon.addEventListener("click", function (e) {
        const video = videoWrap.querySelector("video");

        video.currentTime = 0;
      })
    }

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(video);

      if(this.classList.contains('active')){
        video.play();
      }
    }

    new IntersectionObserver(handleIntersection.bind(video), {rootMargin: '0px 0px 20px 0px'}).observe(video);
  }
}

customElements.define('media-icon-wrap', MediaIconWrap);

class ProductMobileVideo extends HTMLElement {
  constructor() {
    super();

    const video = this.querySelector("video");
    const videoIcon = this.querySelector('.js-video-handle');
    
    videoIcon.addEventListener("click", function (e) {
      videoIcon.classList.toggle("active");      
  
      if(video){
        if (video.paused) {
          video.play();
        }else{
          video.pause();
        }
      }
    });
  }
}

customElements.define('product-mobile-video', ProductMobileVideo);

class LinkPopup extends HTMLAnchorElement {
  constructor() {
    super();

    const target = this.getAttribute('data-id');

    if (!target) return;
    this.addEventListener('click', (e) => {
      e.preventDefault();
      const modal = document.querySelector(target);
      if (modal) modal.show(this);
    });
  }
}

customElements.define('link-popup', LinkPopup, {extends: 'a'});

class UpsellReadMore extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");
    const upsellWrap = this.closest('.product-upsell');
    
    button.addEventListener("click", function (e) {
      const list = upsellWrap.querySelectorAll('.product-upsell__item');
      
      button.classList.add("hide");
      list.forEach((cell) => {
        if(cell.classList.contains('hide')){
          cell.classList.remove('hide');
        }
      })
    });
  }
}

customElements.define('upsell-read-more', UpsellReadMore);

class CustomCountdown extends HTMLElement {
  connectedCallback() {
    const endTime = new Date(this.getAttribute('end-time'));

    this.updateCountdown(endTime);

    this.timerInterval = setInterval(() => {
      this.updateCountdown(endTime);
    }, 1000);
  }

  disconnectedCallback() {
    clearInterval(this.timerInterval);
  }

  updateCountdown(endTime) {
    const now = new Date();
    const diff = endTime - now;

    if (diff <= 0) {
      this.querySelector('.countdown').style.display = 'none';
      clearInterval(this.timerInterval);
      return;
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    const seconds = Math.floor((diff / 1000) % 60);

    this.querySelector('.days').textContent = String(days).padStart(2, '0');
    this.querySelector('.hours').textContent = String(hours).padStart(2, '0');
    this.querySelector('.minutes').textContent = String(minutes).padStart(2, '0');
    this.querySelector('.seconds').textContent = String(seconds).padStart(2, '0');
  }
}

customElements.define('custom-countdown', CustomCountdown);

/*!
 * Jarallax v2.0.4 (https://github.com/nk-o/jarallax)
 * Copyright 2022 nK <https://nkdev.info>
 * Licensed under MIT (https://github.com/nk-o/jarallax/blob/master/LICENSE)
 */
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self).jarallax=t()}(this,(function(){"use strict";function e(e){"complete"===document.readyState||"interactive"===document.readyState?e():document.addEventListener("DOMContentLoaded",e,{capture:!0,once:!0,passive:!0})}let t;t="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};var i=t;const{navigator:o}=i,n=/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(o.userAgent);let a,s;function l(){n?(!a&&document.body&&(a=document.createElement("div"),a.style.cssText="position: fixed; top: -9999px; left: 0; height: 100vh; width: 0;",document.body.appendChild(a)),s=(a?a.clientHeight:0)||i.innerHeight||document.documentElement.clientHeight):s=i.innerHeight||document.documentElement.clientHeight}l(),i.addEventListener("resize",l),i.addEventListener("orientationchange",l),i.addEventListener("load",l),e((()=>{l()}));const r=[];function m(){r.length&&(r.forEach(((e,t)=>{const{instance:o,oldData:n}=e,a=o.$item.getBoundingClientRect(),l={width:a.width,height:a.height,top:a.top,bottom:a.bottom,wndW:i.innerWidth,wndH:s},m=!n||n.wndW!==l.wndW||n.wndH!==l.wndH||n.width!==l.width||n.height!==l.height,c=m||!n||n.top!==l.top||n.bottom!==l.bottom;r[t].oldData=l,m&&o.onResize(),c&&o.onScroll()})),i.requestAnimationFrame(m))}let c=0;class p{constructor(e,t){const i=this;i.instanceID=c,c+=1,i.$item=e,i.defaults={type:"scroll",speed:.5,imgSrc:null,imgElement:".jarallax-img",imgSize:"cover",imgPosition:"50% 50%",imgRepeat:"no-repeat",keepImg:!1,elementInViewport:null,zIndex:-100,disableParallax:!1,disableVideo:!1,videoSrc:null,videoStartTime:0,videoEndTime:0,videoVolume:0,videoLoop:!0,videoPlayOnlyVisible:!0,videoLazyLoading:!0,onScroll:null,onInit:null,onDestroy:null,onCoverImage:null};const n=i.$item.dataset||{},a={};if(Object.keys(n).forEach((e=>{const t=e.substr(0,1).toLowerCase()+e.substr(1);t&&void 0!==i.defaults[t]&&(a[t]=n[e])})),i.options=i.extend({},i.defaults,a,t),i.pureOptions=i.extend({},i.options),Object.keys(i.options).forEach((e=>{"true"===i.options[e]?i.options[e]=!0:"false"===i.options[e]&&(i.options[e]=!1)})),i.options.speed=Math.min(2,Math.max(-1,parseFloat(i.options.speed))),"string"==typeof i.options.disableParallax&&(i.options.disableParallax=new RegExp(i.options.disableParallax)),i.options.disableParallax instanceof RegExp){const e=i.options.disableParallax;i.options.disableParallax=()=>e.test(o.userAgent)}if("function"!=typeof i.options.disableParallax&&(i.options.disableParallax=()=>!1),"string"==typeof i.options.disableVideo&&(i.options.disableVideo=new RegExp(i.options.disableVideo)),i.options.disableVideo instanceof RegExp){const e=i.options.disableVideo;i.options.disableVideo=()=>e.test(o.userAgent)}"function"!=typeof i.options.disableVideo&&(i.options.disableVideo=()=>!1);let s=i.options.elementInViewport;s&&"object"==typeof s&&void 0!==s.length&&([s]=s),s instanceof Element||(s=null),i.options.elementInViewport=s,i.image={src:i.options.imgSrc||null,$container:null,useImgTag:!1,position:"fixed"},i.initImg()&&i.canInitParallax()&&i.init()}css(e,t){return"string"==typeof t?i.getComputedStyle(e).getPropertyValue(t):(Object.keys(t).forEach((i=>{e.style[i]=t[i]})),e)}extend(e,...t){return e=e||{},Object.keys(t).forEach((i=>{t[i]&&Object.keys(t[i]).forEach((o=>{e[o]=t[i][o]}))})),e}getWindowData(){return{width:i.innerWidth||document.documentElement.clientWidth,height:s,y:document.documentElement.scrollTop}}initImg(){const e=this;let t=e.options.imgElement;return t&&"string"==typeof t&&(t=e.$item.querySelector(t)),t instanceof Element||(e.options.imgSrc?(t=new Image,t.src=e.options.imgSrc):t=null),t&&(e.options.keepImg?e.image.$item=t.cloneNode(!0):(e.image.$item=t,e.image.$itemParent=t.parentNode),e.image.useImgTag=!0),!!e.image.$item||(null===e.image.src&&(e.image.src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",e.image.bgImage=e.css(e.$item,"background-image")),!(!e.image.bgImage||"none"===e.image.bgImage))}canInitParallax(){return!this.options.disableParallax()}init(){const e=this,t={position:"absolute",top:0,left:0,width:"100%",height:"100%",overflow:"hidden"};let o={pointerEvents:"none",transformStyle:"preserve-3d",backfaceVisibility:"hidden"};if(!e.options.keepImg){const t=e.$item.getAttribute("style");if(t&&e.$item.setAttribute("data-jarallax-original-styles",t),e.image.useImgTag){const t=e.image.$item.getAttribute("style");t&&e.image.$item.setAttribute("data-jarallax-original-styles",t)}}if("static"===e.css(e.$item,"position")&&e.css(e.$item,{position:"relative"}),"auto"===e.css(e.$item,"z-index")&&e.css(e.$item,{zIndex:0}),e.image.$container=document.createElement("div"),e.css(e.image.$container,t),e.css(e.image.$container,{"z-index":e.options.zIndex}),"fixed"===this.image.position&&e.css(e.image.$container,{"-webkit-clip-path":"polygon(0 0, 100% 0, 100% 100%, 0 100%)","clip-path":"polygon(0 0, 100% 0, 100% 100%, 0 100%)"}),e.image.$container.setAttribute("id",`jarallax-container-${e.instanceID}`),e.$item.appendChild(e.image.$container),e.image.useImgTag?o=e.extend({"object-fit":e.options.imgSize,"object-position":e.options.imgPosition,"max-width":"none"},t,o):(e.image.$item=document.createElement("div"),e.image.src&&(o=e.extend({"background-position":e.options.imgPosition,"background-size":e.options.imgSize,"background-repeat":e.options.imgRepeat,"background-image":e.image.bgImage||`url("${e.image.src}")`},t,o))),"opacity"!==e.options.type&&"scale"!==e.options.type&&"scale-opacity"!==e.options.type&&1!==e.options.speed||(e.image.position="absolute"),"fixed"===e.image.position){const t=function(e){const t=[];for(;null!==e.parentElement;)1===(e=e.parentElement).nodeType&&t.push(e);return t}(e.$item).filter((e=>{const t=i.getComputedStyle(e),o=t["-webkit-transform"]||t["-moz-transform"]||t.transform;return o&&"none"!==o||/(auto|scroll)/.test(t.overflow+t["overflow-y"]+t["overflow-x"])}));e.image.position=t.length?"absolute":"fixed"}o.position=e.image.position,e.css(e.image.$item,o),e.image.$container.appendChild(e.image.$item),e.onResize(),e.onScroll(!0),e.options.onInit&&e.options.onInit.call(e),"none"!==e.css(e.$item,"background-image")&&e.css(e.$item,{"background-image":"none"}),e.addToParallaxList()}addToParallaxList(){r.push({instance:this}),1===r.length&&i.requestAnimationFrame(m)}removeFromParallaxList(){const e=this;r.forEach(((t,i)=>{t.instance.instanceID===e.instanceID&&r.splice(i,1)}))}destroy(){const e=this;e.removeFromParallaxList();const t=e.$item.getAttribute("data-jarallax-original-styles");if(e.$item.removeAttribute("data-jarallax-original-styles"),t?e.$item.setAttribute("style",t):e.$item.removeAttribute("style"),e.image.useImgTag){const i=e.image.$item.getAttribute("data-jarallax-original-styles");e.image.$item.removeAttribute("data-jarallax-original-styles"),i?e.image.$item.setAttribute("style",t):e.image.$item.removeAttribute("style"),e.image.$itemParent&&e.image.$itemParent.appendChild(e.image.$item)}e.image.$container&&e.image.$container.parentNode.removeChild(e.image.$container),e.options.onDestroy&&e.options.onDestroy.call(e),delete e.$item.jarallax}clipContainer(){}coverImage(){const e=this,t=e.image.$container.getBoundingClientRect(),i=t.height,{speed:o}=e.options,n="scroll"===e.options.type||"scroll-opacity"===e.options.type;let a=0,l=i,r=0;return n&&(0>o?(a=o*Math.max(i,s),s<i&&(a-=o*(i-s))):a=o*(i+s),1<o?l=Math.abs(a-s):0>o?l=a/o+Math.abs(a):l+=(s-i)*(1-o),a/=2),e.parallaxScrollDistance=a,r=n?(s-l)/2:(i-l)/2,e.css(e.image.$item,{height:`${l}px`,marginTop:`${r}px`,left:"fixed"===e.image.position?`${t.left}px`:"0",width:`${t.width}px`}),e.options.onCoverImage&&e.options.onCoverImage.call(e),{image:{height:l,marginTop:r},container:t}}isVisible(){return this.isElementInViewport||!1}onScroll(e){const t=this,o=t.$item.getBoundingClientRect(),n=o.top,a=o.height,l={};let r=o;if(t.options.elementInViewport&&(r=t.options.elementInViewport.getBoundingClientRect()),t.isElementInViewport=0<=r.bottom&&0<=r.right&&r.top<=s&&r.left<=i.innerWidth,!e&&!t.isElementInViewport)return;const m=Math.max(0,n),c=Math.max(0,a+n),p=Math.max(0,-n),d=Math.max(0,n+a-s),g=Math.max(0,a-(n+a-s)),u=Math.max(0,-n+s-a),f=1-(s-n)/(s+a)*2;let h=1;if(a<s?h=1-(p||d)/a:c<=s?h=c/s:g<=s&&(h=g/s),"opacity"!==t.options.type&&"scale-opacity"!==t.options.type&&"scroll-opacity"!==t.options.type||(l.transform="translate3d(0,0,0)",l.opacity=h),"scale"===t.options.type||"scale-opacity"===t.options.type){let e=1;0>t.options.speed?e-=t.options.speed*h:e+=t.options.speed*(1-h),l.transform=`scale(${e}) translate3d(0,0,0)`}if("scroll"===t.options.type||"scroll-opacity"===t.options.type){let e=t.parallaxScrollDistance*f;"absolute"===t.image.position&&(e-=n),l.transform=`translate3d(0,${e}px,0)`}t.css(t.image.$item,l),t.options.onScroll&&t.options.onScroll.call(t,{section:o,beforeTop:m,beforeTopEnd:c,afterTop:p,beforeBottom:d,beforeBottomEnd:g,afterBottom:u,visiblePercent:h,fromViewportCenter:f})}onResize(){this.coverImage()}}const d=function(e,t,...i){("object"==typeof HTMLElement?e instanceof HTMLElement:e&&"object"==typeof e&&null!==e&&1===e.nodeType&&"string"==typeof e.nodeName)&&(e=[e]);const o=e.length;let n,a=0;for(;a<o;a+=1)if("object"==typeof t||void 0===t?e[a].jarallax||(e[a].jarallax=new p(e[a],t)):e[a].jarallax&&(n=e[a].jarallax[t].apply(e[a].jarallax,i)),void 0!==n)return n;return e};d.constructor=p;const g=i.jQuery;if(void 0!==g){const e=function(...e){Array.prototype.unshift.call(e,this);const t=d.apply(i,e);return"object"!=typeof t?t:this};e.constructor=d.constructor;const t=g.fn.jarallax;g.fn.jarallax=e,g.fn.jarallax.noConflict=function(){return g.fn.jarallax=t,this}}return e((()=>{d(document.querySelectorAll("[data-jarallax]"))})),d}));
//# sourceMappingURL=jarallax.min.js.map

jarallax(document.querySelectorAll('.jarallax'), {
  speed: 0.2,
});


// Collection badge based on variant
document.querySelectorAll('.section--collection .variant_label--color__image').forEach(variant => {
  variant.addEventListener('mouseover', function() {
    const variantId = this.getAttribute('data-variant-id');
    
    document.querySelectorAll('.section--collection .labor-day-badge').forEach(badge => {
      if (badge.getAttribute('data-variant-id') === variantId) {
        badge.classList.add('is-active');
      } else {
        badge.classList.remove('is-active');
      }
    });
  });
});

// Product badge based on variant
document.querySelectorAll('.product-main-section .variant_label--color__image').forEach(variant => {
  variant.addEventListener('click', function() {
    const variantId = this.getAttribute('data-variant-id');

    document.querySelectorAll('.product-main-section .labor-day-badge').forEach(badge => {
      if (badge.getAttribute('data-variant-id') === variantId) {
        badge.classList.add('is-active');
      } else {
        badge.classList.remove('is-active');
      }
    });
  });
});
